import React from "react";
import classes from "./FQA.module.css";

function Cards({ header, paragraph, collapseID }) {
  return (
    <>
      <div className="card my-2 shadow-sm border-0">
        <div className="card-header p-0">
          <button
            className="btn d-flex justify-content-between align-items-center w-100 p-3 text-start"
            data-bs-toggle="collapse"
            data-bs-target={`#${collapseID}`}
            aria-expanded="false"
            aria-controls={collapseID}
          >
            <span>{header}</span>
            <i className="bi bi-chevron-compact-down"></i>
          </button>
        </div>
        <div id={collapseID} className="collapse" data-bs-parent="#accordion">
          <div className="card-body">{paragraph}</div>
        </div>
      </div>
    </>
  );
}
function FQA() {
  return (
    <>
      <div id="accordion">
        <Cards
          collapseID="collapseOne"
          header="What is RAF Bridging Finance?"
          paragraph="RAF Bridging Finance is a short-term advance that gives you access to a portion of your expected RAF settlement well before the payout is made. This provides immediate financial relief while you wait for the RAF to complete the payment process. "
        />
        <Cards
          collapseID="collapseTwo"
          header="Do I have to claim through an Attorney?"
          paragraph="Yes. Due to the complicated nature of Road Accident Fund (RAF) claims and high court litigation, it is definitely advisable to work through an attorney."
        />
        <Cards
          collapseID="collapseThree"
          header="How Much Are the Monthly Charges?"
          paragraph="The monthly charge depends on how much money you choose to take upfront and how long the Road Accident Fund takes to pay out."
        />
        <Cards
          collapseID="collapseFour"
          header="Bridging Finance vs Loans"
          paragraph="Bridging finance is an advance on money you are due to receive, such as from a property sale or RAF settlement, and is repaid in full once those funds are paid out, with no fixed repayment term. A loan, on the other hand, has a fixed term where the money is borrowed upfront and repaid in regular instalments over that agreed period."
        />
        <Cards
          collapseID="collapseFive"
          header="How fast can I access my Funds?"
          paragraph="Receive your payout within 24 – 48 hours after the relevant documents have been signed."
        />
      </div>
    </>
  );
}

export default FQA;
